<template>
    <div class="layout-external defaultTheme">
        <div class="left">
            <div class="login-box">
                <img
                    :src="logo"
                    class="logo"
                    alt="Logo P2U"
                />
                <router-view></router-view>
            </div>
            <div class="info">
                <span class="material-symbols-outlined">lock</span>
                <p>{{ $t('auth.layout.safe') }}</p>
            </div>
        </div>
        <div class="right">
            <Welcome />
            <!-- <img
                :src="fundoBorda"
                class="bordaLogin"
                alt="Background desktop"
            />
            <img
                :src="backgroundMobile"
                class="background-mobile"
                alt="Background Mobile"
            /> -->
        </div>
    </div>
</template>

<script>
    import { ref, onMounted, defineComponent } from 'vue'
    import Welcome from '@/components/Welcome.vue'

    export default defineComponent({
        name: 'LayoutExterno',

        components: {
            Welcome,
        },

        setup() {
            const logo = new URL('@/assets/images/logoLogin.svg', import.meta.url).href
            const fundoBorda = new URL('@/assets/images/fundobordadireita.svg', import.meta.url)
                .href
            const backgroundMobile = new URL(
                '@/assets/images/background-external-mobile.png',
                import.meta.url,
            ).href

            const carregado = ref(false)

            onMounted(() => {
                carregado.value = true
            })

            return {
                logo,
                fundoBorda,
                backgroundMobile,
                carregado,
            }
        },
    })
</script>

<style lang="scss" scoped>
    /* ================= DESKTOP ================= */
    @include desktop {
        .layout-external {
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin: 0 auto;
            width: 100%;
            height: 100vh;
            padding: 0 5%;
            background-color: #F7FAFE;
            gap: 6rem;
            // overflow: hidden;
            user-select: none;

            .left {
                width: min-content;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                z-index: 10;
                margin-top: 0;
                padding: 0 2rem;
                margin-left: 0;

                .login-box {
                    height: fit-content;
                    background-color: #FFFFFF;
                    width: 27.6875rem;
                    max-width: 27.6875rem;
                    box-shadow: 0 0 1rem 0.1rem #00000020;
                    border-radius: 0.9375rem;
                    padding: 2.5rem;
                    margin-bottom: 1.0625rem;

                    .logo {
                        height: 3.625rem;
                        margin: 0;
                    }
                    
                    // :deep(div), :deep(.container-login) {
                    //     width: 100%;
                    //     max-width: 34rem;
                    // }
                }

                .info {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 0.6rem;
                    color: #6A7890;
                    font-weight: 400;
                    font-size: 0.8rem;
                    text-align: center;
                
                    span {
                        font-size: 1.1rem;
                    }
                }
            }

            .right {
                width: min-content;
                height: 100vh;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .bordaLogin {
                    position: absolute;
                    top: 0;
                    right: 0;
                    height: 100vh;
                    width: auto;   
                    object-fit: cover;
                    z-index: 0;
                }

                // :deep(.welcome-container), :deep(div) {
                //     z-index: 1;
                //     position: relative;
                //     width: 80%;
                //     max-width: 600px;
                //     text-align: center;
                //     display: flex;
                //     flex-direction: column;
                //     align-items: center;
                //     justify-content: center;
                // }

                // :deep(img) {
                //     margin-bottom: -1rem !important; 
                //     transform: scale(1.05);
                // }

                // :deep(h1), :deep(h2) {
                //     margin-top: -1.5rem !important; 
                //     position: relative;
                //     z-index: 2;
                // }
                
                .background-mobile {
                    display: none;
                }
            }
        }
    }

    /* ================= MOBILE e TABLET ================= */
    @include mobile-tablet {
        .layout-external {
            display: flex;
            flex-direction: column;
            min-height: 100vh;
            width: 100vw;
            position: relative;
            overflow-x: hidden;

            .left {
                width: 100%;
                margin: 0;
                padding: 0;
                height: auto;
                display: flex;
                flex-direction: column;
                align-items: center;
                z-index: 2;

                .login-box {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: fit-content;
                    background-color: #FFFFFF;
                    width: 100%;
                    // box-shadow: 0 0 1rem 0.1rem #00000020;
                    border-radius: 0.9375rem;
                    padding: 2.5rem;
                    margin-bottom: 1.0625rem;

                    .logo {
                        margin-top: 4vh;
                        height: 8vh;
                        margin-bottom: 6vh;
                        object-fit: contain;
                    }

                    :deep(.container-login) {
                        margin-top: 0;
                    }
                }

                .info {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 0.6rem;
                    color: #6A7890;
                    font-weight: 400;
                    font-size: 0.8rem;
                    text-align: center;
                    position: absolute;
                    bottom: 3rem;
                
                    span {
                        font-size: 1.1rem;
                    }
                }
            }

            .right {
                width: 100%;
                position: static;

                :deep(div),
                .bordaLogin {
                    display: none;
                }

                .background-mobile {
                    display: block;
                    position: fixed;
                    bottom: 0;
                    right: 0;
                    width: 100%;
                    max-height: 54vh;
                    object-fit: cover;
                    z-index: 1;
                    opacity: 1;
                }
            }
        }
    }
</style>
